import { Http } from "@/util";

export function listReceipt(param) {
  return Http.post("/admin/invoice/list", param);
}

export function listDetails(invoiceId) {
  return Http.get("/admin/invoice/order/detail/list", { invoiceId });
}

export function addReceipt(param) {
  return Http.post("/admin/invoice/add", param);
}

export function modifyReceipt(param) {
  return Http.post("/admin/invoice/update", param);
}

export function uploadInvoice(param) {
  return Http.post("/admin/invoice/upload/invoice", param);
}

export function modifyInvoiceOrder(param) {
  return Http.post("/admin/invoice/order/modify", param);
}

export function delInvoiceOrder(param) {
  return Http.post("/admin/invoice/order/del", param);
}
